

import {treeDataConversion} from './treeData';
import http from '../../axios/http';


let orgUtil = {
    findOrg : '',
}

orgUtil.findOrg = (data, callback) => {
    http.post({
        url: '/auth/findOrgTree',
        data: data,
        success: (res) => {
            treeDataConversion(res);
            callback(res);
        }
    });
}

export default orgUtil;